

 export interface Project {
    title: string;
    description: string;
    tech: string;
    live: string;
    github: string;
 }

export const projects: Project[] = [
    {
     title: "Zaschboard-Management-Board",
    description: "An interactive management board leveraging Redux and a local backend for efficient task and employee management. Integrates AI-generated summarized notes, real-time updates, and smart filtering, providing quick insights and enhancing workflow productivity for seamless team coordination",
    tech: "React, Tailwind, Gemini API, Firebase, Redux",
     live: "https://zaschboard.netlify.app/",
     github: "https://github.com/DebasmitaBHowmick/Zaschboard-Management-Board",
    
    },
    {
        title: "MyNote-App",
        description: "Built an offline-first Notes mobile application using React Native CLI, TypeScript, Redux Toolkit, and SQLite, with automatic background data synchronization to a Node.js backend when network connectivity is restored.",
        tech: "React-Native, Redux, SQLite, Node js, express js typescript",
        github: "https://github.com/DebasmitaBHowmick/MyNote-App-Frontend-React-Native",
        live: ""
    },

    {
    title: "CodeCamp eCommerce",
    description: "Designed and implemented a complete e-commerce platform featuring product browsing, cart management, and checkout flow. The frontend is built with React, while the backend (including JWT authentication) was self-developed using JSON Server.",
    tech: "React, Tailwind, JWT Token, Redux",
     live: "https://codecamp-ebook.netlify.app/",
     github: "https://github.com/DebasmitaBHowmick/CodeCamp"
    },
    {
        title: "E-Cube",
        description: "E-Cube is a sleek, fully responsive web app for effortless show booking. Enjoy one-click reservations powered by Redux state management, secure Firebase authentication.Track every booking in real time and experience a smooth, mobile-friendly interface from start to finish.",
        tech: "React, Firebase, Redux, Tailwind",
        live: "https://ecubeshow.netlify.app/",
        github: "https://github.com/DebasmitaBHowmick/e-cube"
     },
    {
     title: "MyChat-Bot",
    description: "MyChat-Bot is a web app that lets users upload or drag-and-drop images to generate concise captions or have real time conversations using Google Gemini AI. It features real-time image previews and smooth user interactions. The project demonstrates practical skills in state management, asynchronous API integration, and AI-powered web development.",
    tech: "React, Tailwind, Gemini API ",
    live: "https://mychatbot256.netlify.app/",
    github: "https://github.com/DebasmitaBHowmick/myChatBot"
    },
    {
    title: "Weather-Here",
    description: "An responsive weather application built with React, showing real-time forecasts, air quality, and location-based weather updates using the WeatherAPI.",
    tech: "React, React-Query, Tailwind",
    live: "https://weatherhere2025.netlify.app/",
    github: "https://github.com/DebasmitaBHowmick/Weather-Here"
    },
    {
     title: "NewsYatra",
    description: "A React-powered News App that delivers the latest headlines in real time using the News API.Browse trending stories, search by keywords, and enjoy a fast, responsive interface for an effortless news-reading experience on any device.",
    tech: "React, Tailwind, React-Router",
    live: "https://newsyatraindia.netlify.app/",
    github: "https://github.com/DebasmitaBHowmick/News-yatra"
    }
]